import React from "react";
import { Button } from 'antd';
import { useState } from 'react';
import {DownloadOutlined} from "@ant-design/icons";

const DownloadButton = ({onClick}) => {
    const [state, setState] = useState({ background: "#FFFFFF", borderColor: "#3F3D56", color: "#3F3D56" });
    return (
        <Button
            onMouseEnter={() => setState({...state, background: "#3F3D56", borderColor: "#3F3D56", color: "#FFFFFF" })}
            onMouseLeave={() => setState({...state, background: "#FFFFFF", borderColor: "#3F3D56", color: "#3F3D56" })}
            onClick={onClick}
            style={state}
            icon={<DownloadOutlined />}
        >
        Скачать
        </Button>
    );
}
export default DownloadButton;